import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const FeatureDetail = ({ 
  icon, 
  title, 
  description, 
  details, 
  image, 
  color, 
  reverse = false 
}) => {
  const colorClasses = {
    'from-blue-500 to-cyan-500': 'from-blue-500 to-cyan-500',
    'from-green-500 to-emerald-500': 'from-green-500 to-emerald-500',
    'from-purple-500 to-pink-500': 'from-purple-500 to-pink-500',
    'from-orange-500 to-red-500': 'from-orange-500 to-red-500',
    'from-indigo-500 to-blue-500': 'from-indigo-500 to-blue-500',
    'from-teal-500 to-green-500': 'from-teal-500 to-green-500'
  };

  return (
    <div className="mb-8">
      <div className={`grid lg:grid-cols-2 gap-16 items-center ${reverse ? 'lg:grid-flow-col-dense' : ''}`}>
        <motion.div
          className={`${reverse ? 'lg:col-start-2' : ''}`}
          initial={{ opacity: 0, x: reverse ? 50 : -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="flex items-center gap-4 mb-8">
            <div className={`w-16 h-16 rounded-2xl flex items-center justify-center bg-gradient-to-r ${colorClasses[color]} shadow-lg flex-shrink-0`}>
              <div className="w-8 h-8 text-white">
                {icon}
              </div>
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">{title}</h2>
          </div>
          
          <p className="text-lg text-gray-600 leading-relaxed mb-8">{description}</p>
          
          <ul className="space-y-4">
            {details.map((detail, index) => (
              <motion.li
                key={index}
                className="flex items-center gap-3 text-gray-700 font-medium"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                <span>{detail}</span>
              </motion.li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          className={`${reverse ? 'lg:col-start-1' : ''}`}
          initial={{ opacity: 0, x: reverse ? -50 : 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src={image} 
              alt={title}
              className="w-full h-96 object-cover transition-transform duration-300 hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 to-secondary-500/10 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default FeatureDetail;
